
    /**
     * @Author: sunchao
     * @Date:   2019/5/27 15:41
     */
    import {Component, Vue} from "vue-property-decorator";
    import Step from "@/components/Step.vue";
    import {auth, getServiceLable, silenceAuth, getUserInfo} from "@/api";
    import utils from "@/util";
    import config from "../../public/js/config";
    import Base64 from "../util/base664";

    @Component({
        components: {
            Step,
        },
    })
    export default class RealAuthentication extends Vue {
        private labelList: number[] = [];
        private loading: boolean = false;
        private enable: boolean = true;
        private key: string = "";
        private redirect: string = "";
        private userinfostr: string = "";
        private userinfo = {
            name: "",
            idCard: "",
            mobilePhone: "",
            password: "",
            source: "",
            provice: "",
            city: "",
            area: ""
        };

        private created() {
            this.checkIsFirstAuth();
            try {
                this.redirect = String(this.$route.query.redirect) ? String(this.$route.query.redirect) : config.wechatBase;
                // this.userinfostr = String(this.$route.query.info) ? String(this.$route.query.info) : "eyJuYW1lIjoiIiwiaWRDYXJkIjoiIiwibW9iaWxlUGhvbmUiOiIiLCJwYXNzd29yZCI6IiIsInNvdXJjZSI6IiIsInByb3ZpY2UiOiIiLCJjaXR5IjoiIiwiYXJlYSI6IiJ9";
                // const base64 = new Base64()
                // this.userinfo = JSON.parse(base64.decode(decodeURIComponent(this.userinfostr)));
                if (this.$route.query.info === "") {
                    this.enable = true;
                    throw Error("用户信息错误");
                } else {
                    // this.getLabel();
                    this.enable = false;
                }
            } catch (e) {
                this.$dialog.alert({
                    message: "非法操作！",
                }).then(() => {
                    history.back();
                });
            }
        }

        /**
         * 检查是否为第一次实人认证
         * @param userGuid
         */
        private checkIsFirstAuth() {
            getUserInfo().then((resp: any) => {
                if (resp.succ===true) {

                }else {
                    this.$dialog.alert({
                        message: "非法操作",
                    }).then(() => {
                        window.location.href = config.wechatBase + "#/userCenter";
                    });
                }
            });
        }

        /**
         * 获取唇语文本
         * @param sessionId 当前会话的sessionId
         */
        private getLabel(): void {
            getServiceLable(JSON.stringify(this.userinfo)).then((resp: any) => {
                if (resp.data.succ) {
                    this.enable = false;
                    this.labelList = resp.data.data.label.split("");
                    this.key = resp.data.data.key;
                } else if (resp.status === 20051) {
                    this.$dialog.alert({
                        message: "用户正在认证中,请稍后再试!",
                    }).then(() => {
                        history.back();
                    });
                } else if (resp.status === 20053) {
                    this.$dialog.alert({
                        message: "读数验证码过期，重新加载...",
                    }).then(() => {
                        this.getLabel();
                    });
                } else if (resp.status === 20060) {
                    this.$dialog.alert({
                        message: "用户信息过期，请重新确认认证信息!",
                    }).then(() => {
                        history.back();
                    });
                } else {
                    this.$dialog.alert({
                        message: "认证信息加载失败，请重新认证!",
                    }).then(() => {
                        history.back();
                    });
                }

            });
        }

        /**
         * 打开手机原生摄像头进行录像
         */
        private watchCameraFile(e: any): void {
            const file: File = e.target.files[0];
            const size: number = file.size / 1024 / 1024;
            // 大于20M时不能上传
            if (size > 20) {
                this.$dialog.alert({
                    message: "视频文件过大，请重新拍摄。",
                });
                return;
            }
            const formData = new FormData();
            formData.append("file", file);
            this.loading = true;
            this.uploadVideo(formData);
        }

        /**
         * 上传视频和校验
         * @param formData
         */
        private uploadVideo(formData: FormData) {
            const headerConfig: any = {
                "Content-Type": "multipart/form-data",
            };
            this.enable = true;
            silenceAuth(formData, headerConfig).then((resp: any) => {
                this.loading = false;
                const { succ } = resp;
                if (succ) {
                    this.$dialog.alert({
                        message: "认证成功！",
                    }).then(() => {
                        if (this.redirect === "") {
                            window.location.href = config.wechatBase;
                        } else {
                            let url = decodeURIComponent(this.redirect);
                            if (url.indexOf('?', 0) > 1) {
                                window.location.href = decodeURIComponent(this.redirect) + "&info=" + encodeURIComponent(this.userinfostr);
                            } else {
                                window.location.href = decodeURIComponent(this.redirect) + "?info=" + encodeURIComponent(this.userinfostr);
                            }
                        }
                    });
                } else {
                    if (resp.status === 10059) {
                        this.$dialog.alert({
                            message: "认证出错，请稍后再试！",
                        }).then(() => {
                            history.back();
                        });
                    } else if (resp.status === 20051) {
                        this.$dialog.alert({
                            message: "当前用户正在认证中...",
                        }).then(() => {
                            history.back();
                        });
                    } else if (resp.status === 10056 || resp.status === 10054) {
                        this.$dialog.alert({
                            message: "人脸识别未通过!",
                        }).then(() => {
                            history.back();
                        });
                    } else if (resp.status === 10055 || resp.status === 10057) {
                        this.$dialog.alert({
                            message: "实人认证未通过!",
                        }).then(() => {
                            history.back();
                        });
                    } else {
                        this.$dialog.alert({
                            message: "认证失败，请重新认证！",
                        }).then(() => {
                            history.back();
                        });
                    }
                }
            }).catch(() => {
                this.$dialog.alert({
                    message: "认证出错，请稍后再试！",
                }).then(() => {
                    history.back();
                });
            });
        }
    }
